import Link from "next/link"
import gql from "graphql-tag"
import { useQuery } from "react-apollo"

import "./founder-reading.scss"

const RECENT_POSTS = gql`
  query FOUNDER_READING {
    blogArticles(first: 30, skip: 0, orderBy: "createdAt_DESC") {
      id
      title
      slug
      shortDescription
      previewPicUrl
      previewPicAlt
    }
  }
`

// A first, rule-based "reading" pick (no AI): one post about the skill the
// member is looking for, one about working with a co-founder, newest first.
// Blog posts have no tags, so the rules match titles.
const TOPIC_BY_SKILL = {
  1: /technical|cto|developer|engineer|build/i,
  2: /design|ux|mvp/i,
  3: /marketing|growth|users|launch/i,
  4: /partner|business|customer|sales/i,
  5: /sales|customer|revenue|pricing/i,
  6: /product|mvp|validat|idea/i,
}
const CO_FOUNDER = /co-?founder|equity|partner/i

export const pickReading = (posts, wantsSkills) => {
  const list = posts || []
  const wanted = (wantsSkills || []).map((s) => Number(s.itemId))
  const topic = wanted.map((id) => TOPIC_BY_SKILL[id]).find(Boolean)
  const picks = []
  const add = (post) => {
    if (post && !picks.includes(post)) picks.push(post)
  }
  if (topic) add(list.find((p) => topic.test(p.title)))
  add(list.find((p) => CO_FOUNDER.test(p.title) && !picks.includes(p)))
  list.forEach((p) => picks.length < 2 && add(p))
  return picks.slice(0, 2)
}

const FounderReading = ({ me }) => {
  const { data } = useQuery(RECENT_POSTS, { ssr: false })
  const posts = pickReading(data && data.blogArticles, me && me.wantsSkills)
  if (posts.length === 0) return null

  return (
    <div className="founder-reading">
      <h2 className="founder-reading__title">Reading for this week</h2>
      <div className="founder-reading__grid">
        {posts.map((post) => (
          <Link key={post.id} href="/blog/post/[slug]" as={`/blog/post/${post.slug}`}>
            <a className="founder-reading__card">
              {post.previewPicUrl && (
                <img
                  className="founder-reading__img"
                  src={post.previewPicUrl}
                  alt=""
                  loading="lazy"
                  width="480"
                  height="240"
                />
              )}
              <span className="founder-reading__body">
                <span className="founder-reading__name">{post.title}</span>
                {post.shortDescription && (
                  <span className="founder-reading__desc">{post.shortDescription}</span>
                )}
              </span>
            </a>
          </Link>
        ))}
      </div>
    </div>
  )
}

export default FounderReading
